import React, { useState, useEffect } from "react";
import "./sidebar.scss";
import "../../../styles/global.scss";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
// @ts-ignore
import Cookies from "js-cookie";
// import Auth from "@aws-amplify/auth";

interface SidebarProps {
  active: string;
}

const Sidebar: React.FunctionComponent<SidebarProps> = (props) => {
  const navigate = useNavigate();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [isOrgEmployee, setIsOrgEmployee] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [aegDropdown, setAegDropdown] = useState(false);
  const [brandDropdown, setBrandDropdown] = useState(false);
  const [isActivated, setIsActivated] = useState(false);
  // const [partnerDropdown, setPartnerDropdown] = useState(false);

  useEffect(() => {
    const userType = Cookies.get("UserType");
    const userRole = Cookies.get("UserRole");
    const isActivated = Cookies.get("IsActivated");
    if (isActivated === "true") {
      setIsActivated(true);
    }
    if (userType === "administrative" && userRole === "super_admin") {
      setIsSuperAdmin(true);
    } else if (userType === "partner") {
      setIsPartner(true);
    } else if (userType === "organization") {
      setIsOrgEmployee(true);
    }
  }, []);

  // const logOut = (): void => {
  //   Cookies.remove("UserType");
  //   Cookies.remove("UserRole");
  //   Auth.signOut().then(() => {
  //     navigate("/");
  //   });
  // };

  return (
    <div className="sidebar2">
      <div
        className={
          sidebarCollapsed ? "menuiconSidebarCollapsed" : "menuiconSidebar"
        }
      >
        <div className="menuSidebarLogo">
          <Link to="#">
            <img src="/svgs/logo.svg" alt="" />
          </Link>
        </div>
        <>
          <div className="menuSidebarItem mt-2">
            <Row className="menuItemRow">
              <Col
                sm={3}
                lg={3}
                xl={3}
                className={
                  props.active !== "dashboard"
                    ? "menuItemRowLogo"
                    : "menuItemRowLogoActive"
                }
              >
                <Link to="#">
                  <img
                    src={
                      props.active !== "dashboard"
                        ? "/svgs/dashboard-icon-1.svg"
                        : "/svgs/dashboard-icon.svg"
                    }
                    alt="svg"
                    onClick={() => {
                      setSidebarCollapsed(!sidebarCollapsed);
                      // setPartnerDropdown(false);
                      setBrandDropdown(false);
                      setAegDropdown(false);
                    }}
                  />
                </Link>
              </Col>
              {!sidebarCollapsed && (
                <Col sm={9} lg={9} xl={9} className="menuItemRowTitle">
                  <div
                    className="menuDropdown"
                    onClick={() => {
                      if (isOrgEmployee) {
                        navigate("/BrandDashboard");
                      } else if (isSuperAdmin) {
                        navigate("/AdminDashboard");
                      } else if (isPartner) {
                        navigate("/PartnerDashboard");
                      }
                    }}
                  >
                    <p className="menuItemRowTitle">Dashboard</p>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </>
        {(isOrgEmployee || isSuperAdmin) && (
          <>
            <div className="menuSidebarItem mt-2">
              <Row className="menuItemRow">
                <Col
                  sm={3}
                  lg={3}
                  xl={3}
                  className={
                    props.active !== "brand"
                      ? "menuItemRowLogo"
                      : "menuItemRowLogoActive"
                  }
                >
                  <Link to="#">
                    <img
                      src={
                        props.active !== "brand"
                          ? "/svgs/box-fill2.svg"
                          : "/svgs/box-fill2-white.svg"
                      }
                      alt="svg"
                      onClick={() => {
                        setSidebarCollapsed(!sidebarCollapsed);
                        // setPartnerDropdown(false);
                        setBrandDropdown(false);
                        setAegDropdown(false);
                      }}
                    />
                  </Link>
                </Col>
                {!sidebarCollapsed && (
                  <Col sm={9} lg={9} xl={9} className="menuItemRowTitle">
                    <div
                      className="menuDropdown"
                      onClick={() => {
                        setBrandDropdown(!brandDropdown);
                      }}
                    >
                      <p className="menuItemRowTitle">Brand Management</p>
                      <img
                        src={
                          brandDropdown
                            ? "/svgs/chevron-up.svg"
                            : "/svgs/chevron-down.svg"
                        }
                        alt=""
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </div>
            {brandDropdown && (
              <div className="dropdownItem">
                <p
                  className="sidebarsubtitle"
                  onClick={() => navigate("/OrganizationManagement")}
                >
                  Organization
                </p>
                <p
                  className="sidebarsubtitle"
                  onClick={() => navigate("/BrandManagement")}
                >
                  Brands
                </p>
                <p
                  className="sidebarsubtitle"
                  onClick={() => navigate("/ProductList")}
                >
                  Products
                </p>
              </div>
            )}
          </>
        )}
        {(isPartner || isSuperAdmin) && (
          <>
            <div className="menuSidebarItem mt-2">
              <Row className="menuItemRow">
                <Col
                  sm={3}
                  lg={3}
                  xl={3}
                  className={
                    props.active !== "partner"
                      ? "menuItemRowLogo"
                      : "menuItemRowLogoActive"
                  }
                >
                  <Link to="#">
                    <img
                      src={
                        props.active !== "partner"
                          ? "/svgs/people-fill.svg"
                          : "/svgs/people-fill-white.svg"
                      }
                      alt="svg"
                      onClick={() => {
                        setSidebarCollapsed(!sidebarCollapsed);
                        // setPartnerDropdown(false);
                        setBrandDropdown(false);
                        setAegDropdown(false);
                      }}
                    />
                  </Link>
                </Col>
                {!sidebarCollapsed && (
                  <Col sm={9} lg={9} xl={9} className="menuItemRowTitle">
                    <div
                      className="menuDropdown"
                      onClick={() => navigate("/PartnerManagement")}
                    >
                      <p className="menuItemRowTitle">Partner Management </p>
                      {/* <img
                        src={
                          partnerDropdown
                            ? "/svgs/chevron-up.svg"
                            : "/svgs/chevron-down.svg"
                        }
                        alt=""
                      /> */}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
            {/* {partnerDropdown && (
              <div className="dropdownItem">
                <p
                  className="sidebarsubtitle"
                  onClick={() => navigate("/PartnerManagement")}
                >
                  Partners
                </p>
              </div>
            )} */}
          </>
        )}

        {isActivated && (
          <div className="menuSidebarItem mt-2">
            <Row className="menuItemRow">
              <Col
                sm={3}
                lg={3}
                xl={3}
                className={
                  props.active !== "discovery"
                    ? "menuItemRowLogo"
                    : "menuItemRowLogoActive"
                }
              >
                <Link to="#">
                  <img
                    src={
                      props.active !== "discovery"
                        ? "/svgs/search.svg"
                        : "/svgs/search-white.svg"
                    }
                    alt="svg"
                    onClick={() => {
                      setSidebarCollapsed(!sidebarCollapsed);
                      // setPartnerDropdown(false);
                      setBrandDropdown(false);
                      setAegDropdown(false);
                    }}
                  />
                </Link>
              </Col>
              {!sidebarCollapsed && (
                <Col sm={9} lg={9} xl={9} className="menuItemRowTitle">
                  <div
                    className="menuDropdown"
                    onClick={() => {
                      if (isOrgEmployee) {
                        navigate("/discoverymanagement/org&&brand");
                      } else if (isPartner) {
                        navigate("/discoverymanagement/partner");
                      } else if (isSuperAdmin) {
                        navigate("/discoverymanagement/org&&admin");
                      }
                    }}
                  >
                    <p className="menuItemRowTitle">Discovery Management</p>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        )}
        {(isOrgEmployee || isSuperAdmin) && isActivated && (
          <>
            <div className="menuSidebarItem mt-2">
              <Row className="menuItemRow">
                <Col
                  sm={3}
                  lg={3}
                  xl={3}
                  className={
                    props.active !== "advisory"
                      ? "menuItemRowLogo"
                      : "menuItemRowLogoActive"
                  }
                >
                  <Link to="#">
                    <img
                      src={
                        props.active !== "advisory"
                          ? "/svgs/file-earmark-medical-fill.svg"
                          : "/svgs/file-earmark-medical-fill -white.svg"
                      }
                      alt="svg"
                      onClick={() => {
                        setSidebarCollapsed(!sidebarCollapsed);
                        // setPartnerDropdown(false);
                        setBrandDropdown(false);
                        setAegDropdown(false);
                      }}
                    />
                  </Link>
                </Col>
                {!sidebarCollapsed && (
                  <Col sm={9} lg={9} xl={9} className="menuItemRowTitle">
                    <div
                      className="menuDropdown"
                      onClick={() => {
                        if (isOrgEmployee) {
                          navigate("/advisorymanagement/brand");
                        } else if (isSuperAdmin) {
                          navigate("/advisorymanagement/admin");
                        }
                      }}
                    >
                      <p className="menuItemRowTitle">Advisory Management</p>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </>
        )}

        {isSuperAdmin && (
          <>
            <div className="menuSidebarItem mt-2">
              <Row className="menuItemRow">
                <Col
                  sm={3}
                  lg={3}
                  xl={3}
                  className={
                    props.active !== "settings"
                      ? "menuItemRowLogo"
                      : "menuItemRowLogoActive"
                  }
                >
                  <Link to="#">
                    <img
                      src={
                        props.active !== "settings"
                          ? "/svgs/gear-fill.svg"
                          : "/svgs/gear-fill-white.svg"
                      }
                      alt="svg"
                      onClick={() => {
                        setSidebarCollapsed(!sidebarCollapsed);
                        // setPartnerDropdown(false);
                        setBrandDropdown(false);
                        setAegDropdown(false);
                      }}
                    />
                  </Link>
                </Col>
                {!sidebarCollapsed && (
                  <Col sm={9} lg={9} xl={9}>
                    <div
                      className="menuDropdown"
                      onClick={() => {
                        setAegDropdown(!aegDropdown);
                        navigate("/SettingsList");
                      }}
                    >
                      <p className="menuItemRowTitle">Settings</p>
                      {/* <img
                        src={
                          aegDropdown
                            ? "/svgs/chevron-up.svg"
                            : "/svgs/chevron-down.svg"
                        }
                        alt=""
                      /> */}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
            {/* {aegDropdown && (
              <div className="dropdownItem">
                <p
                  className="sidebarsubtitle"
                  onClick={() => navigate("/AdminUsersList")}
                >
                  User Management
                </p>
                {isSuperAdmin && (
                  <p
                    className="sidebarsubtitle"
                    onClick={() => navigate("/documentsettings")}
                  >
                    Document Settings
                  </p>
                )}
              </div>
            )} */}
          </>
        )}
        {/* <div className="collapseSection mt-auto mb-3">
          <Row className="footerRow">
            <Col md={3}>
              <Link to="#">
                <img src="/svgs/power.svg" alt="svg" onClick={logOut} />
              </Link>
            </Col>

            {!sidebarCollapsed && (
              <Col md={9}>
                <p className="logoutTitle" onClick={logOut}>
                  Logout
                </p>
              </Col>
            )}
          </Row>
        </div> */}
        <div className="collapseSection mt-auto mb-3 mt-3">
          <Row className="footerRow">
            <Col md={3}>
              <Link to="#">
                <img
                  onClick={() => {
                    setSidebarCollapsed(!sidebarCollapsed);
                    // setPartnerDropdown(false);
                    setBrandDropdown(false);
                    setAegDropdown(false);
                  }}
                  src={
                    sidebarCollapsed
                      ? "/svgs/chevron-double-right.svg"
                      : "/svgs/chevron-double-left.svg"
                  }
                  alt="svg"
                />
              </Link>
            </Col>
            {!sidebarCollapsed && (
              <Col md={9}>
                <p
                  className="collapseSectionTitle"
                  onClick={() => {
                    setSidebarCollapsed(!sidebarCollapsed);
                    // setPartnerDropdown(false);
                    setBrandDropdown(false);
                    setAegDropdown(false);
                  }}
                >
                  Collapse
                </p>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
